export enum Area {
  TREATMENT_NOW = 'treatmentNow',
  ACCESS_TO_MEDICATION = 'accessToMedication'
}
